import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { UploadFile } from '../UploadFile/UploadFile';
import { selectFilePendingConfirmation, useUploadingFiles } from '../../state/selectors';
import { FilePendingConfirmationModal } from '../FilePendingConfirmationModal/FilePendingConfirmationModal';

export const UploadFileList: React.FC = () => {
  const uploadingFiles = useUploadingFiles();

  const filePendingConfirmation = useSelector(selectFilePendingConfirmation);

  return (
    <Box>
      {Object.entries(uploadingFiles).map(([fileId, file]) => (
        <UploadFile key={fileId} fileId={fileId} file={file} />
      ))}

      {filePendingConfirmation && (
        <FilePendingConfirmationModal fileData={filePendingConfirmation} />
      )}
    </Box>
  );
};
